import React from "react";
import PropTypes from "prop-types";
import { Header } from "semantic-ui-react";

import { styles, styles1 } from "./element";

const NewInText = ({ name, color, ...props }) => (
  <Header
    size="small"
    content={name}
    {...props}
    style={color ? styles1.text_color : styles}
  />
);

NewInText.propTypes = {
  name: PropTypes.string,
};
export default NewInText;
